import { GameType } from "../../../models/GameType";
import styles from "./Card.module.scss";

const IMAGE = "/images/cover.png";

interface CardProps {
  card: any;
  handleChoice: any;
  flipped: boolean;
  disabled: boolean;
  id: string;
}

const options: GameType[] = [
  { title: "Addition", type: "+", id: 0 },
  { title: "Multiplication", type: "·", id: 1 },
  { title: "Subtraction", type: "-", id: 2 },
  { title: "Division", type: ":", id: 3 },
];

const Card = (props: CardProps) => {
  const { card, handleChoice, flipped, disabled, id } = props;
  const handleClick = () => {
    if (!disabled) {
      handleChoice(card);
    }
  };

  return (
    <div className={styles.card}>
      <div className={flipped ? styles.flipped : ""}>
        <div className={styles.memoryCard}>
          {card.image === false
            ? `${card.num1} ${
                options.find((option) => option.id === Number(id))?.type
              } ${card.num2}`
            : `${card.result}`}
        </div>
        <img className={styles.cardCover} src={IMAGE} onClick={handleClick} />
      </div>
    </div>
  );
};

export default Card;
